<template lang="pug">
v-col(cols=12 xl=10)
  template(v-if="loading")
    v-skeleton-loader.fill-width(
      type=`card-heading, divider,
        list-item-two-line, divider,
        list-item-two-line, divider,
        list-item-two-line, divider,
        list-item-two-line, divider
      `
    )
  template(v-else)
    v-row(no-gutters).mb-5
      v-col.flex-grow-1
        h2 {{ entityName }}
      v-col.flex-grow-0
        v-btn.mb-2(
          bottom
          color="primary"
          dark
          rounded
          depressed
          text
          :to=`{ name: 'Teaching' }`
        ) К ведению курсов
    lesson-task(
      v-for="(task, idx) in tasks"
      :key="idx"
      :task="task"
      is-consult
    )
    v-alert(
      v-if="!tasks.length"
      type="info"
      text
    )
      span Выполнение заданий не предусмотрено

</template>

<script>
import LessonTask from '@/modules/Education/Courses/components/Lessons/LessonTask.vue';

export default {
  components: {
    LessonTask,
  },
  data() {
    return {
      tasks: null,
      loading: true,
    };
  },
  computed: {
    entityName() {
      switch (this.$route.query.type) {
        case 'lesson': {
          return 'Урочные задания';
        }
        case 'unit': {
          return 'Тематические задания';
        }
        default: {
          return 'Курсовые задания';
        }
      }
    },
    userId() {
      return this.$route.query.user;
    },
    subjectId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getTasks();
    },
    async getTasks() {
      this.loading = true;
      const get = {
        lesson: this.getLesson,
        unit: this.getUnit,
        course: this.getCourse,
      };
      await get[this.$route.query.type]();
      this.loading = false;
    },
    getLesson() {
      const params = { expand: 'user_tasks' };
      return this.$rHandler(
        this.$api.lessons.getUserLesson(this.subjectId, this.userId, params),
        ({ data }) => {
          this.tasks = data.data.user_tasks;
        },
      );
    },
    getUnit() {
      const params = { expand: 'user_tasks' };
      return this.$rHandler(
        this.$api.courseUnits.getCourseUnitUser(
          this.subjectId,
          this.userId,
          params,
        ),
        ({ data }) => {
          this.tasks = data.data.user_tasks;
        },
      );
    },
    async getCourse() {
      const { items } = await this.$api.users.coursesTasks(
        this.userId, this.subjectId,
      );
      this.tasks = items;
      return items;
    },
  },
};
</script>
